export default `



            ██      ██
           █  █    █  █
            

          █            █
           ██        ██
             ████████

`